var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7647 16.5455V14.3636C13.7647 11.9535 15.6607 10 18 10C20.3396 10 22.2353 11.9527 22.2353 14.3636V16.5455C22.7034 16.5455 23.1523 16.7371 23.4833 17.0781C23.8142 17.4192 24.0001 17.8817 24 18.364V24.1818C23.9994 25.1857 23.2097 25.9994 22.2353 26H13.7647C13.2966 26 12.8477 25.8084 12.5167 25.4673C12.1858 25.1263 11.9999 24.6637 12 24.1815V18.3636C12.0006 17.3597 12.7903 16.5461 13.7647 16.5455ZM13.4118 18.364V24.1818C13.4118 24.3826 13.5698 24.5455 13.7647 24.5455H22.2353C22.4294 24.5455 22.5882 24.3818 22.5882 24.1815V18.3636C22.5882 18.1628 22.4302 18 22.2353 18H13.7647C13.5706 18 13.4118 18.1636 13.4118 18.364ZM20.8235 14.3636V16.5455H15.1765V14.3636C15.1765 12.757 16.4406 11.4545 18 11.4545C19.56 11.4545 20.8235 12.756 20.8235 14.3636Z",
    fill: "#B6B8BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock3);
export default __webpack_public_path__ + "static/media/lock3.cd1c66949abaa81c2747dec773353ffc.svg";
export { ForwardRef as ReactComponent };